import styled from 'styled-components';
import { ELLIPSIS } from '@optimus-web/core';
import EntityTitle from '../../../../components/commander-ui/EntityTitle';

const DescriptionElement = styled.small`
    ${ELLIPSIS}
`;

const StyledDiv = styled.div`
    max-width: 100%;
`;

interface Props {
    description?: React.ReactNode;
    children?: React.ReactNode;
    imageUrl?: string;
}

const TwoLineTitle = (props: Props) => (
    <StyledDiv>
        <EntityTitle imageUrl={props.imageUrl}>{props.children}</EntityTitle>
        {props.description && <DescriptionElement>{props.description}</DescriptionElement>}
    </StyledDiv>
);

export default TwoLineTitle;
